
import './echo';
import LazyLoad from 'vanilla-lazyload';
// import select2 from 'select2';
import { decrypt } from './helpers.js';
import * as Sentry from "@sentry/browser";
// select2();

//=========================INIT VARIABLES=======================================
// let maxSelected = 10; // Límite máximo de selección
let table;
let currentRotation = 180;
let ajaxExecuted = false;
let isTableReady = false;
let dataTableConfig = {
    scrollCollapse: true,
    searching: false,
    autoWidth: false,
    paging: false,  // Oculta la paginación
    info: false,
    dom: 't',
    lengthChange: false,
    "stateSave": true,
    "bStateSave": true,
    ordering: true,
    // pageLength: 10, // Número de filas por defecto
    // order: [[4, 'asc']],
    order: [],
    columnDefs: [
        { width: 'auto', targets: '_all' },
        { orderable: false, targets: [1, 2, -1, -2] },
        // { visible: false, targets: [-1] },
        // {
        //     targets: [0],
        //     orderSequence: ["asc", "desc"]
        // },
        // {
        //     targets: [4],
        //     orderSequence: ["asc"]
        // },
        // {
        //     targets: [3],
        //     orderSequence: ["desc"]
        // }
    ]
};
Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_FRONT_DNS,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            // https://docs.sentry.io/platforms/javascript/session-replay/privacy/#privacy-configuration
            // NOTE: This will disable built-in masking. Only use this if your site has no sensitive data, or if you've already set up other options for masking or blocking relevant data, such as 'ignore', 'block', 'mask' and 'maskFn'.
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    // Tracing
    tracesSampleRate: 0.1, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: import.meta.env.VITE_APP_ENV,
});
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then(registration => {
            console.log('Service Worker registrado con éxito:', registration);
        })
        .catch(error => {
            console.error('Error al registrar el Service Worker:', error);
        });
}

// PWA Install Logic
let deferredPrompt;
const installBtn = document.getElementById('pwa-install-btn');
const installBtnMobile = document.getElementById('pwa-install-btn-mobile');

window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent standard browser prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    deferredPrompt = e;
    // Update UI notify the user they can install the PWA
    if (installBtn) installBtn.classList.remove('d-none');
    if (installBtnMobile) installBtnMobile.classList.remove('d-none');
});

const triggerInstall = async () => {
    if (!deferredPrompt) return;
    // Show the install prompt
    deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;
    // Optionally, send analytics event with outcome of user choice
    console.log(`User response to the install prompt: ${outcome}`);
    // We've used the prompt, and can't use it again, throw it away
    deferredPrompt = null;
    // Hide our custom install button
    if (installBtn) installBtn.classList.add('d-none');
    if (installBtnMobile) installBtnMobile.classList.add('d-none');
};

if (installBtn) installBtn.addEventListener('click', triggerInstall);
if (installBtnMobile) installBtnMobile.addEventListener('click', triggerInstall);

window.addEventListener('appinstalled', (event) => {
    console.log('👍', 'appinstalled', event);
    // Hide our custom install button
    if (installBtn) installBtn.classList.add('d-none');
    if (installBtnMobile) installBtnMobile.classList.add('d-none');
    // Clear the deferredPrompt
    deferredPrompt = null;
});
// document.addEventListener('DOMContentLoaded', function () {
//     console.log('imprimiendo error en sentry','env:',import.meta.env.VITE_APP_ENV,import.meta.env.VITE_SENTRY_FRONT_DNS);
//     Sentry.captureMessage('Error de prueba en Sentry 4');
// });
//================================================================
const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    use_native: false,
    threshold: 0,
    callback_loaded: (el) => {
        el.classList.add('lazy-loaded');
    },
    callback_enter: (el) => {
        if (el.id == 'blog-posts' && !ajaxExecuted) {
            console.log('ejecutado ajax');
            getBlogPosts();
            ajaxExecuted = true;
        }
    }
});

window.Echo.channel('dollarRateChannel')
    .listen('.rateUpdatedEvent', function (data) {
        if (data.newRates.length > 0 && isTableReady) {
            $.each(data.newRates, function (k, rate) {
                let buyDiff = `<span class="font-12 text-neutral-gray">= `;
                let sellDiff = buyDiff;
                if (rate.buy_diff > 0) {
                    buyDiff = `<span class="font-12 text-success-300"> <i class="bi bi-arrow-up-short"></i>`;
                } else if (rate.buy_diff < 0) {
                    buyDiff = `<span class="font-12 text-error"> <i class="bi bi-arrow-down-short"></i>`;
                }
                buyDiff += `${parseFloat(rate.buy_diff).toFixed(3)}</span>`;
                if (rate.sell_diff > 0) {
                    sellDiff = `<span class="font-12 text-error"> <i class="bi bi-arrow-up-short"></i>`;
                } else if (rate.sell_diff < 0) {
                    sellDiff = `<span class="font-12 text-success-300"> <i class="bi bi-arrow-down-short"></i>`;
                }
                sellDiff += `${parseFloat(rate.sell_diff).toFixed(3)}</span>`;

                // Update Desktop Table
                let $row = $('#exchange-companies tbody tr[data-company="' + rate.company + '"]');
                if ($row.length) {
                    $row.find('td:nth-child(4)').data('rate', parseFloat(rate.buy).toFixed(3));
                    $row.find('.div-rate-buy').text(parseFloat(rate.buy).toFixed(3));
                    $row.find('.div-rate-buy-diff').html(buyDiff);

                    $row.find('td:nth-child(5)').data('rate', parseFloat(rate.sell).toFixed(3));
                    $row.find('.div-rate-sell').text(parseFloat(rate.sell).toFixed(3));
                    $row.find('.div-rate-sell-diff').html(sellDiff);

                    $row.addClass('table-warning');
                    $row.find('.blinking-text').removeClass('d-none');
                }

                // Update Mobile Card as well
                let $card = $(`.exchange-mobile-card[data-company="${rate.company}"]`);
                if ($card.length) {
                    $card.find('.div-rate-buy').text(parseFloat(rate.buy).toFixed(3));
                    $card.find('.div-rate-buy-diff').html(buyDiff);
                    $card.find('.div-rate-sell').text(parseFloat(rate.sell).toFixed(3));
                    $card.find('.div-rate-sell-diff').html(sellDiff);
                    $card.addClass('table-warning');
                }

                setTimeout(() => {
                    $('#exchange-companies tbody tr[data-company="' + rate.company + '"]').removeClass('table-warning').find('.blinking-text').addClass('d-none');
                    $(`.exchange-mobile-card[data-company="${rate.company}"]`).removeClass('table-warning');
                }, 4000);
            });

            // Re-draw DataTable to maintain sorting/filtering if necessary
            if ($.fn.DataTable.isDataTable('#exchange-companies')) {
                $('#exchange-companies').DataTable().rows().invalidate().draw(false);
            }

            updateAmountIntable();
        }
    });

// INICIO DE CARGADO DE DATA
async function loadDataTable() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    return new Promise(function (resolve, reject) {
        $.ajax({
            url: GET_RATE,
            type: 'POST',
            success: function (response) {
                resolve(response);
            },
            error: function (err) {
                reject(err) // Reject the promise and go to catch()
            }
        });
    });

}

async function BindDataTableAndSelectOptions(response) {
    console.log('BindDataTableAndSelectOptions');
    let decryptedData = decrypt(response.data, 'comparaeldolar.com');
    let jsonData = JSON.parse(decryptedData);
    let exchangeCompanyBody = $('#exchange-companies tbody');
    // let dropdownIntro = $('#intro-dropdown');
    exchangeCompanyBody.html('');
    $('.mobile-cards-container').html('');
    var sortedData = Object.entries(jsonData);
    sortedData.sort(function (a, b) {
        return a[0].localeCompare(b[0]); // Compara las claves (slugs)
    });

    $.each(sortedData, function (index, item) {  // item es un array: [slug, data]
        var slug = item[0];  // La clave (slug)
        var data = item[1];  // Los datos asociados a ese slug
        var classCard = (index % 2 === 0) ? 'offset-1' : ' ms-1 ';
        $('#exchangeHousesList').append(`
                <div class="card col-5 mb-1 ${classCard}">
                    <div class="card-body">
                        <div class="d-flex flex-column gap-2">
                            <label class="form-check cursor-pointer">
                                <input class="form-check-input" type="checkbox" name="alert-exchanges[]" value="${slug}">
                                <span class="form-check-label">${data.name}</span>  <!-- Agregué el slug para que sea más claro -->
                            </label>
                        </div>
                    </div>
            </div>`);
    });
    $.each(jsonData, function (slug, data) {
        if (slug == 'sbs') {
            let metadata = JSON.parse(data.metadata);
            const euro = metadata.find(data => data.coin === 'Euro');
            $('#sbs-buy').text(data.buy);
            $('#sbs-sell').text(data.sell);
            $('#euro-buy').text(euro.buy);
            $('#euro-sell').text(euro.sell);
            return;
        }
        // Crear un objeto Date a partir de created_at
        const createdAt = new Date(data.created_at);
        const now = new Date();
        const diffInMs = now - createdAt;
        const diffInHours = diffInMs / (1000 * 60 * 60);
        if (diffInHours > 48) {
            return;
        }
        // select.append($('<option>', {
        //     value: slug,
        //     "data-sell": data.sell,
        //     "data-buy": data.buy,
        //     text: data.name
        // }))
        // dropdownIntro.append($('<option>', {
        //     value: slug,
        //     text: data.name
        // }))
        //



        let sellDiff, buyDiff = '';
        if (data.sell_diff < 0) {
            sellDiff = ` <span class="font-12 text-success-300"> <i class="bi bi-arrow-down-short"></i>`;
        } else if (data.sell_diff > 0) {
            sellDiff = ` <span class="font-12 text-error"> <i class="bi bi-arrow-up-short"></i>`;
        } else {
            sellDiff = `<span class="font-12 text-neutral-gray"> =`;
        }
        sellDiff += `${data.sell_diff ? parseFloat(data.sell_diff).toFixed(3) : 0}</span>`;

        if (data.buy_diff < 0) {
            buyDiff = ` <span class="font-12 text-error"> <i class="bi bi-arrow-down-short"></i>`;
        } else if (data.buy_diff > 0) {
            buyDiff = ` <span class="font-12 text-success-300"> <i class="bi bi-arrow-up-short"></i>`;
        } else {
            buyDiff = `<span class="font-12 text-neutral-gray"> =`;
        }
        buyDiff += `${data.buy_diff ? parseFloat(data.buy_diff).toFixed(3) : 0}</span>`;
        let companyMetadata = data.company_metadata ? JSON.parse(data.company_metadata) : null;
        //<i data-company="${slug}" class="bi bi-star me-2 btn-star cursor_pointer"></i>
        // Desktop Table Append
        exchangeCompanyBody.append(`
            <tr data-company="${slug}" class="text-center">
                            <td class="text-start px-0">
                                <span class="d-none">${slug}</span>
                                <picture>
                                    <source type="image/webp"
                                        srcset="${PUBLIC_PATH_COMPANIES}/${data.logo.replace('.svg', '.webp')}">
                                    <img
                                    src="${PUBLIC_PATH_COMPANIES}/${data.logo}" alt="logo ${slug}"
                                    class="exchange-company-logo cursor_pointer"
                                    loading="lazy"
                                    width="140"
                                    height="50"/>
                                </picture>
                                    <i class="btn-more-details bi bi-plus-circle d-inline d-lg-none cursor_pointer"></i>
                                <br>

                                <b class="error blinking-text font-12 d-none">TC Actualizado!</b>
                            </td>
                            <td class="text-center d-none d-lg-table-cell">${companyMetadata ? formatColumnBanks(companyMetadata.direct_banks) : ''}</td>
                            <td class="font-12 text-center d-none d-lg-table-cell">${companyMetadata ? companyMetadata.schedule : ''}</td>
                            <td class="font-16 text-neutral  text-lg-start" data-rate="${data.buy.toFixed(3)}">
                                <div class="div-rate-buy text-center">${data.buy.toFixed(3)}</div>
                                <div class="div-rate-buy-diff text-center">
                                ${buyDiff}
                                </div>
                            </td>
                            <td class="font-16 text-neutral text-lg-start" data-rate="${data.sell.toFixed(3)}">
                                <div class="div-rate-sell text-center ">${data.sell.toFixed(3)}</div>
                                <div class="div-rate-sell-diff text-center">
                                    ${sellDiff}
                                </div>

                            </td>

                            <td class="text-center">
                                <div class="table-amount px-2 d-inline-flex fw-semibold text-success-300"></div>
                            </td>
                             <td class="text-center d-none d-lg-table-cell">
                                <div class="action-buttons-desktop d-flex align-items-center justify-content-center gap-2">
                                    <button class="btn btn-sm btn-outline-error compare-btn"
                                        data-action="compare-table"
                                        data-image="${data.logo}"
                                        data-company="${slug}"
                                        data-bs-toggle="tooltip" data-bs-html="true" data-bs-custom-class="ced-tooltip" data-bs-title="Comparar este casa de cambio.">
                                        <i class="bi bi-heart"></i>
                                    </button>
                                    <a class="btn btn-sm btn-visit-desktop btn-company-link"
                                        href="${data.site}?utm_source=comparaeldolar"
                                        rel="noreferrer nofollow" target="_blank"
                                        data-action="go-change-table"
                                        data-company="${slug}"
                                        data-bs-toggle="tooltip" data-bs-html="true" data-bs-custom-class="ced-tooltip" data-bs-title="Ir a la web de la casa de cambio."
                                        aria-label="ir a la pagina de ${slug}">
                                        Visitar
                                    </a>
                                </div>
                             </td>

                        </tr>
        `);

        $('.mobile-cards-container').append(`
            <div class="exchange-mobile-card" data-company="${slug}" data-name="${data.name}">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="logo-container">
                        <picture>
                            <source type="image/webp" srcset="${PUBLIC_PATH_COMPANIES}/${data.logo.replace('.svg', '.webp')}">
                            <img src="${PUBLIC_PATH_COMPANIES}/${data.logo}" alt="logo ${slug}" width="100" height="35">
                        </picture>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                        <span class="mobile-amount-label">RECIBES:</span>
                        <div class="mobile-amount-value total-amount-mobile table-amount fw-bold"></div>
                    </div>
                </div>
                <div class="card-rates-mobile">
                    <div class="rate-box buy">
                        <span class="label">Compra:</span>
                        <span class="value div-rate-buy">${data.buy.toFixed(3)}</span>
                        <span class="diff div-rate-buy-diff">${buyDiff}</span>
                    </div>
                    <div class="rate-box sell">
                        <span class="label">Venta:</span>
                        <span class="value div-rate-sell">${data.sell.toFixed(3)}</span>
                        <span class="diff div-rate-sell-diff">${sellDiff}</span>
                    </div>
                </div>
                <div class="card-actions-mobile">
                    <button class="btn-info-toggle btn-card-details d-flex align-items-center justify-content-center" data-company="${slug}">
                        <i class="bi bi-plus-circle"></i> Más
                    </button>
                    <button class="btn-fav-mobile btn-outline-error compare-btn" data-company="${slug}" data-image="${data.logo}" data-action="compare-table">
                        <i class="bi bi-heart"></i>
                    </button>
                    <a href="${data.site}?utm_source=comparaeldolar" class="btn-visit-mobile btn-company-link" target="_blank" data-company="${slug}" data-action="go-change-table">
                        Visitar <i class="bi bi-arrow-right"></i>
                    </a>
                </div>
                <div class="card-details-mobile details-animate" id="details-${slug}">
                    <div class="details-grid">
                        <div class="detail-item">
                            <span class="label">Bancos directos:</span>
                            <span class="val">${companyMetadata ? formatColumnBanks(companyMetadata.direct_banks) : '-'}</span>
                        </div>
                        <div class="detail-item">
                            <span class="label">Horario:</span>
                            <span class="val">${companyMetadata ? companyMetadata.schedule : '-'}</span>
                        </div>
                    </div>
                </div>
            </div>
        `);
    })
    lazyLoadInstance.update();
    const dt = (await import('datatables.net-bs5')).default;
    // const dtr = (await import('datatables.net-responsive-bs5')).default;

    table = $('#exchange-companies').DataTable(dataTableConfig);
    isTableReady = true;
    table.on('draw.dt', function () {
        console.log('ajuste');
        adjustTableColumns();
    });
}

$(document).on('click', '.compare-btn', function () {
    let company = $(this).data('company');
    let isAdding = !$(this).hasClass('btn-error');

    // Toggle all buttons of the same company first to avoid sync conflicts
    $('.compare-btn[data-company="' + company + '"]').each(function () {
        if (isAdding) {
            $(this).addClass('btn-error').removeClass('btn-outline-error').find('i').addClass('bi-heart-fill').removeClass('bi-heart');
        } else {
            $(this).removeClass('btn-error').addClass('btn-outline-error').find('i').removeClass('bi-heart-fill').addClass('bi-heart');
        }
    });

    if (isAdding) {
        let imgName = $(this).data('image');
        // Find visible image for animation
        let productImage = $('tr[data-company="' + company + '"] img, .exchange-mobile-card[data-company="' + company + '"] img').filter(':visible').first();

        if (productImage.length) {
            const imagePosition = productImage.offset();
            const clonedImage = productImage.clone()
                .addClass('cloned-image')
                .css({
                    position: 'absolute',
                    top: imagePosition.top,
                    left: imagePosition.left,
                    width: productImage.width(),
                    height: productImage.height(),
                    zIndex: 1000
                }).appendTo('body');

            const cartBox = $('#heart-counter-label');
            const cartPosition = cartBox.offset();

            clonedImage.animate({
                top: cartPosition.top,
                left: cartPosition.left,
                width: 50,
                height: 50,
            }, 500, function () {
                setTimeout(() => {
                    clonedImage.remove();
                    updateBtnStatus();
                    cartBox.addClass('shaking');
                }, 1000);
                setTimeout(() => {
                    cartBox.removeClass('shaking');
                }, 2000);
            });
        } else {
            updateBtnStatus();
        }
    } else {
        updateBtnStatus();
    }

    trackEvent({
        'event': 'click',
        'value': company,
        'action': 'compare'
    }, true);
});

function updateBtnStatus() {
    let options = [];
    $('.compare-btn.btn-error').each(function () {
        options.push($(this).data('company'));
    });
    // Remove duplicates
    options = [...new Set(options)];

    setLocalStorageItem("options", JSON.stringify(options));
    $('#heart-counter-label').html(`<i class="text-error bi bi-heart-fill"></i> (${options.length})`);

    // Sync UI for all same-company buttons
    $('.compare-btn').each(function () {
        let slug = $(this).data('company');
        if (options.includes(slug)) {
            $(this).addClass('btn-error').removeClass('btn-outline-error').find('i').addClass('bi-heart-fill').removeClass('bi-heart');
        } else {
            $(this).removeClass('btn-error').addClass('btn-outline-error').find('i').removeClass('bi-heart-fill').addClass('bi-heart');
        }
    });

    if ($('#switchFavorites').is(':checked')) {
        filterTableRows()
    }

    // Update calculator if it's currently showing favorites
    if ($('#switchFavoritesCalculator').is(':checked')) {
        updateBestOptions();
    }
}

$('#heart-counter-label').on('click', function () {
    document.getElementById("apply-btn").scrollIntoView({ behavior: "smooth" });
});

// function formatResultIntro(option) {
//     if (!option.id) {
//         return option.text;
//     }
//     console.log(option);
//     let container = $(
//         '<div><img width="50" src="' + PUBLIC_PATH_COMPANIES + '/' + option.id + '.svg" class="img-flag me-3" /> ' + option.text + '</div>'
//     );
//     return container
// }
const introModal = new bootstrap.Modal(document.getElementById('introModal'))
async function init() {

    if (!getLocalStorageItem("visitorId")) {
        // introModal.show();
        setLocalStorageItem("operation", "sell");
        setLocalStorageItem("calculator-amount", "1000");
        setLocalStorageItem("calc-mode", "have");
    }
    try {
        let response = await loadDataTable();
        await BindDataTableAndSelectOptions(response);
        runApp();
        updateAmountIntable();
    } catch (error) {
        console.error("Error de carga:", error);
        alert('Ocurrió un error inesperado por favor recarga la pagina para continuar.');
    }

    // $('#banks-filter').select2({
    //     // theme: 'bootstrap-5',
    //     templateResult: formatResult, // Plantilla para mostrar las opciones con checkbox
    //     templateSelection: formatSelection,
    //     placeholder: 'Bancos',
    //     width: '100%',
    //     tags: false,
    //     // maximumSelectionLength: maxSelected,
    //     // closeOnSelect: true,
    //     // allowClear: true,
    // });
    let timeToAskForFeedback = 600;//10 mit.
    let counter = 0;
    if (getLocalStorageItem('timeCounter')) {
        counter = parseInt(getLocalStorageItem('timeCounter'), 10);
    } else {
        setLocalStorageItem('timeCounter', counter);
    }
    if (counter <= timeToAskForFeedback) {
        // Actualiza el contador cada segundo
        let timerfeedback = setInterval(function () {
            counter++;
            setLocalStorageItem('timeCounter', counter);
            // Comprueba si el contador ha superado los 100 segundos
            if (counter > timeToAskForFeedback) {
                setLocalStorageItem('timeCounter', counter);
                clearInterval(timerfeedback);
                $('#feedbackButton').trigger('click');
            }
        }, 1000);
    }

}
// function formatResult(option) {
//     if (!option.id) {
//         return option.text;
//     }
//     // if ($('.multiSelect:visible').val().includes(option.id)) {
//     //     option.selected = true;
//     // } else {
//     //     option.selected = false;
//     // }

//     // Crear un checkbox que esté marcado si la opción está seleccionada
//     let checkbox = $(`<input class="form-check-input" type="checkbox">`).attr('checked', option.selected);
//     // Crear un contenedor para el checkbox y el texto de la opción
//     let $container = $('<span></span>');
//     $container.append(checkbox).append(' ' + option.text);

//     return $container;
// }
// function formatSelection(data, container) {
//     let btn = $(container).find('button');
//     btn.html('<i class="bi bi-x"></i>');
//     $(btn).insertAfter($(btn).next());

//     let $container = $('<span></span>');
//     $container.text(data.text);
//     return $container;
// };

// Funciones auxiliares para acceder de forma segura a localStorage
function getLocalStorageItem(key) {
    try {
        return localStorage.getItem(key);
    } catch (error) {
        console.warn(`Error al acceder a localStorage para la clave "${key}":`, error);
        return null; // Retorna null si localStorage no está disponible
    }
}

function setLocalStorageItem(key, value) {
    try {
        localStorage.setItem(key, value);
    } catch (error) {
        console.warn(`Error al guardar en localStorage para la clave "${key}":`, error);
    }
}



function runApp() {
    if (!getLocalStorageItem('visitorId')) {
        setLocalStorageItem('visitorId', crypto.randomUUID());
    }

    // Restore Calculator State
    if (getLocalStorageItem("operation")) {
        let op = getLocalStorageItem("operation");
        $(`#op-input-${op}`).prop('checked', true);

        // State Reset
        $('.op-card').removeClass('active');

        // State Active
        $(`#op-${op}`).addClass('active');
    }

    if (getLocalStorageItem("calc-mode")) {
        let mode = getLocalStorageItem("calc-mode");
        $(`#mode-input-${mode}`).prop('checked', true);
    }

    if (getLocalStorageItem("calculator-amount")) {
        $('input.calculator-amount').val(getLocalStorageItem("calculator-amount"));
    }

    updateCalculatorUI();
    initTooltips();
    adjustTableColumns();
    initBtnStatuses();

    // Default favorites switch state for calculator
    if (getLocalStorageItem("calculator_favorites_active") === "true") {
        $('#switchFavoritesCalculator').prop('checked', true);
    } else {
        // If not set, default to true as per request: "por defecto muestre las 3 mejores de mis favoritos"
        // Wait, the request says "por defecto muestre las 3 mejores de mis favoritos"
        // Let's set it to true if it's the first time
        if (getLocalStorageItem("calculator_favorites_active") === null) {
            $('#switchFavoritesCalculator').prop('checked', true);
            setLocalStorageItem("calculator_favorites_active", "true");
        }
    }
}

function updateCalculatorUI() {
    let operation = $('input[name="operation"]:checked').val(); // buy, sell
    let mode = $('input[name="calc-mode"]:checked').val(); // have, want

    let label = "";
    let currencyCode = "";
    let flagPath = BASE_URL + "/images/";

    if (operation === 'sell') {
        if (mode === 'have') {
            label = "Monto que tienes";
            currencyCode = "PEN";
            flagPath += "peru.svg";
        } else {
            label = "Quiero recibir";
            currencyCode = "USD";
            flagPath += "usa.svg";
        }
    } else { // buy
        if (mode === 'have') {
            label = "Monto que tienes";
            currencyCode = "USD";
            flagPath += "usa.svg";
        } else {
            label = "Monto que quieres recibir";
            currencyCode = "PEN";
            flagPath += "peru.svg";
        }
    }

    $('#input-label').text(label);
    $('#calc-currency-code').text(currencyCode);
    $('#calc-currency-flag').attr('src', flagPath);

    updateAmountIntable();
    updateBestOptions(); // Ensure best options are updated when UI changes
}

$('#switchFavoritesCalculator').on('change', function () {
    let isActive = $(this).is(":checked");
    setLocalStorageItem("calculator_favorites_active", isActive);
    updateBestOptions();
});

function initBtnStatuses() {
    let options = JSON.parse(getLocalStorageItem("options")) || [];
    setLocalStorageItem("options", JSON.stringify(options));

    // Restore Hearts
    $('.compare-btn').addClass('btn-outline-error').removeClass('btn-error').find('i').addClass('bi-heart').removeClass('bi-heart-fill');
    if (options.length > 0) {
        options.forEach(function (ele) {
            $('.compare-btn[data-company="' + ele + '"]').removeClass('btn-outline-error').addClass('btn-error').find('i').removeClass('bi-heart').addClass('bi-heart-fill');
        });
        $('#heart-counter-label').html(`<i class="text-error bi bi-heart-fill"></i> (${options.length})`);
    } else {
        $('#heart-counter-label').html(`<i class="text-error bi bi-heart"></i> (0)`);
    }

    // Restore Global Favorites Filter Switch
    if (getLocalStorageItem("favorites_active") === "true") {
        $('#switchFavorites').prop('checked', true);
        filterTableRows();
    }
}
$('#switchFavorites').on('change', function () {
    let isActive = $('#switchFavorites').is(":checked");
    setLocalStorageItem("favorites_active", isActive);
    if (isActive) {
        filterTableRows();
    } else {
        $("#exchange-companies tbody tr, .exchange-mobile-card").show();
        $('#nothing-to-compare-advice').hide();
    }
})
function filterTableRows() {
    let options = JSON.parse(getLocalStorageItem("options")) || [];
    $("#exchange-companies tbody tr, .exchange-mobile-card").each(function () {
        let companyName = $(this).attr("data-company");
        if (companyName && typeof companyName === "string") {
            let match = options.includes($(this).attr("data-company").toLowerCase());
            $(this).toggle(match);
        } else {
            $(this).hide();
        }
    });
    if (options.length == 0 && $('#switchFavorites').is(":checked")) {
        $('#nothing-to-compare-advice').show();
    } else {
        $('#nothing-to-compare-advice').hide();
    }
}

$(document).ready(function () {
    init();
});
$(window).resize(adjustTableColumns);

$('.op-card').on('click', function () {
    let id = $(this).attr('id');
    let op = id === 'op-buy' ? 'buy' : 'sell';

    // State Toggle
    $('.op-card').removeClass('active');
    $(this).addClass('active');

    $(`#op-input-${op}`).prop('checked', true);
    setLocalStorageItem("operation", op);
    updateCalculatorUI();
    orderTable();
});

$('#btn-swap-mode').on('click', function () {
    let currentMode = $('input[name="calc-mode"]:checked').val();
    let newMode = currentMode === 'have' ? 'want' : 'have';

    $(`#mode-input-${newMode}`).prop('checked', true);
    setLocalStorageItem("calc-mode", newMode);

    // Animation effect
    $('.calculator-input-wrapper').css({ opacity: 0.5 });
    setTimeout(() => {
        $('.calculator-input-wrapper').css({ opacity: 1 });
    }, 150);

    updateCalculatorUI();
    orderTable();
});

$('input.calculator-amount').on('change keyup', function (event) {
    setLocalStorageItem("calculator-amount", $(this).val());
    updateAmountIntable();
});
$('#extraSort').on('change', function (event) {
    let selection = $(this).val();
    if (typeof table !== 'undefined' && $.fn.DataTable.isDataTable(table)) {
        switch (selection) {
            case 'bbuy':
                table.order([[3, 'desc']]).draw();
                sortMobileCards('buy', 'desc');
                break;
            case 'bsale':
                table.order([[4, 'asc']]).draw();
                sortMobileCards('sell', 'asc');
                break;
            case 'name_asc':
                table.order([[0, 'asc']]).draw();
                sortMobileCards('name', 'asc');
                break;
            case 'name_desc':
                table.order([[0, 'desc']]).draw();
                sortMobileCards('name', 'desc');
                break;
            default:
                break;
        }
    }
});

function sortMobileCards(type, order) {
    let container = $('.mobile-cards-container');
    let cards = container.find('.exchange-mobile-card').get();
    cards.sort(function (a, b) {
        if (type === 'name') {
            let valA = ($(a).data('name') || '').toString().toLowerCase();
            let valB = ($(b).data('name') || '').toString().toLowerCase();
            return order === 'asc' ? valA.localeCompare(valB) : valB.localeCompare(valA);
        } else {
            let valA = parseFloat($(a).find(`.div-rate-${type}`).text());
            let valB = parseFloat($(b).find(`.div-rate-${type}`).text());
            return order === 'asc' ? valA - valB : valB - valA;
        }
    });
    $.each(cards, function (i, card) {
        container.append(card);
    });
}
function adjustTableColumns() {
    console.log("adjustTableColumns");
    if (getLocalStorageItem('DataTables_exchange-companies_/')) {
        let dtOptions = JSON.parse(getLocalStorageItem('DataTables_exchange-companies_/'));
        if (dtOptions.order && dtOptions.order[0]) {
            let orderIndex = dtOptions.order[0][0];
            if (orderIndex !== undefined) {
                $('#exchange-companies td,#exchange-companies th').removeClass('shadow bg-body-tertiary');
                $('#exchange-companies td:nth-child(' + (orderIndex + 1) + '),#exchange-companies th:nth-child(' + (orderIndex + 1) + ')').addClass('shadow bg-body-tertiary');
            }
        }
    }
}

$(document).on('click', 'td:has(.btn-more-details:visible)', function () {
    var $tr = $(this).closest('tr'); // La fila principal
    let company = $tr.data('company');
    var $hiddenTds = $tr.find('td.d-none').not(':last-child'); // Selecciona los <td> ocultos, excluyendo el último
    var $thead = $tr.closest('table').find('thead'); // El encabezado de la tabla

    if ($tr.next().hasClass('details-row')) {
        // Si ya hay una fila de detalles, la elimina (oculta los detalles)
        $tr.next().remove();
        $(this).find('.bi-dash-circle').addClass('bi-plus-circle').removeClass('bi-dash-circle');
    } else {
        $(this).find('.bi-plus-circle').removeClass('bi-plus-circle').addClass('bi-dash-circle');
        // Crea una nueva fila debajo de la principal
        var $detailsRow = $('<tr class="details-row" data-company="' + company + '"><td colspan="7"></td></tr>');
        var $detailsCell = $detailsRow.find('td');

        // Crear un contenedor con 'd-flex' y 'justify-content-between'
        var $cardContainer = $('<div class="d-flex justify-content-evenly flex-wrap"></div>');

        // Clona los TDs ocultos (excluyendo el último) y los añade al contenedor como cards
        $hiddenTds.each(function (index) {
            var $th = $thead.find('th').eq($(this).index()); // Encuentra el <th> correspondiente
            var headerText = $th.text(); // Obtiene el texto del encabezado
            var tdContent = $(this).html(); // Obtiene el contenido del <td>

            // Crea la estructura de la card
            var $card = $('<div class="card mb-3 border-0"></div>');
            var $cardBody = $('<div class="card-body p-2"></div>');
            var $cardTitle = $('<b class="font-16 mb-1"></b>').text(headerText);
            var $cardText = $('<p class="font-14"></p>').html(tdContent);

            // Ensambla la card
            $cardBody.append($cardTitle).append($cardText);
            $card.append($cardBody);
            $cardContainer.append($card);
        });

        // Añade el contenedor de cards a la celda de detalles
        $detailsCell.append($cardContainer);

        // Inserta la nueva fila debajo de la fila principal
        $tr.after($detailsRow);
    }

});


function updateAmountIntable() {
    let amountStr = $('#calculator-amount').val().replace(/,/g, '');
    let amount = parseFloat(amountStr) || 0;
    let operation = $('input[name="operation"]:checked').val(); // buy, sell
    let mode = $('input[name="calc-mode"]:checked').val(); // have, want

    let resultLabel = "RECIBES";
    let rankingHeader = "Monto de cambio";

    // Dynamic Labels based on 4 Cases
    if (operation === 'sell') {
        if (mode === 'have') { // Case 1: HAVE S/ -> BUY USD. Result USD
            resultLabel = "RECIBES";
            rankingHeader = "RECIBES";
        } else { // Case 2: WANT USD -> BUY USD. Result S/
            resultLabel = "PAGAS";
            rankingHeader = "PAGAS";
        }
    } else { // sell
        if (mode === 'have') { // Case 3: HAVE USD -> SELL USD. Result S/
            resultLabel = "RECIBES";
            rankingHeader = "RECIBES";
        } else { // Case 4: WANT S/ -> SELL USD. Result USD
            resultLabel = "ENVÍAS";
            rankingHeader = "ENVÍAS";
        }
    }

    // Update table header if on desktop
    $('#exchange-companies thead th:nth-child(6)').html(rankingHeader);

    $('#exchange-companies tbody tr, .exchange-mobile-card').each(function () {
        let $this = $(this);
        let rateBuy = parseFloat($this.find('.div-rate-buy').text()) || 0;
        let rateSell = parseFloat($this.find('.div-rate-sell').text()) || 0;

        let amountCompany = 0;
        let coinSymbol = 'S/';

        if (operation === 'sell') {
            if (mode === 'have') { // Case 1: amount PEN / rateSell
                amountCompany = amount / rateSell;
                coinSymbol = '$';
            } else { // Case 2: amount USD * rateSell
                amountCompany = amount * rateSell;
                coinSymbol = 'S/';
            }
        } else { // sell
            if (mode === 'have') { // Case 3: amount USD * rateBuy
                amountCompany = amount * rateBuy;
                coinSymbol = 'S/';
            } else { // Case 4: amount PEN / rateBuy
                amountCompany = amount / rateBuy;
                coinSymbol = '$';
            }
        }

        let formatted = coinSymbol + ' ' + formatNumberWithDecimals(amountCompany.toFixed(2));

        // Update Desktop
        $this.find('.table-amount').text(formatted);

        // Update Mobile Label
        $this.find('.mobile-amount-label').text(resultLabel);
        $this.find('.mobile-amount-value').text(formatted);
    });

    updateBestOptions();
}

function updateBestOptions() {
    console.log('updateBestOptions');
    let operation = $('input[name="operation"]:checked').val(); // buy, sell
    console.log('operation', operation);
    let mode = $('input[name="calc-mode"]:checked').val(); // have, want
    console.log('mode', mode);
    let amountStr = $('#calculator-amount').val().replace(/,/g, '');
    let amount = parseFloat(amountStr) || 0;

    let companies = [];

    $('#exchange-companies tbody tr').each(function () {
        let $this = $(this);
        let slug = $this.data('company');
        let name = $this.find('img').attr('alt').replace('logo ', '');
        let logo = $this.find('img').attr('src');
        let rateBuy = parseFloat($this.find('.div-rate-buy').text()) || 0;
        let rateSell = parseFloat($this.find('.div-rate-sell').text()) || 0;
        let site = $this.find('.btn-company-link').attr('href');

        if (rateBuy > 0 && rateSell > 0) {
            companies.push({
                slug, name, logo, rateBuy, rateSell, site
            });
        }
    });
    // console.log('companies', companies);

    // Filter by Favorites if switch is active
    let isFavoritesActive = $('#switchFavoritesCalculator').is(':checked');
    let favoriteOptions = JSON.parse(getLocalStorageItem("options")) || [];

    if (isFavoritesActive) {
        companies = companies.filter(c => favoriteOptions.includes(c.slug));
    }

    // Sort based on Operation
    if (operation === 'sell') {
        // Buy USD -> User wants the LOWEST Sell rate from house
        companies.sort((a, b) => a.rateSell - b.rateSell);
    } else {
        // Sell USD -> User wants the HIGHEST Buy rate from house
        companies.sort((a, b) => b.rateBuy - a.rateBuy);
    }

    let top3 = companies.slice(0, 3);
    let container = $('#best-options-container');
    container.html('');

    if (top3.length === 0) {
        let emptyMsg = isFavoritesActive ? 'No tienes casas favoritas seleccionadas' : 'No hay datos disponibles';
        container.html(`<div class="text-center p-3 text-muted" style="font-size: 0.8rem;">${emptyMsg}</div>`);
        return;
    }

    top3.forEach(company => {
        let amountCompany = 0;
        let currencySymbol = 'S/';

        if (operation === 'sell') {
            if (mode === 'have') { // PEN -> USD
                amountCompany = amount / company.rateSell;
                currencySymbol = '$';
            } else { // USD -> PEN (Pagas)
                amountCompany = amount * company.rateSell;
                currencySymbol = 'S/';
            }
        } else { // buy
            if (mode === 'have') { // USD -> PEN
                amountCompany = amount * company.rateBuy;
                currencySymbol = 'S/';
            } else { // PEN -> USD (Envías)
                amountCompany = amount / company.rateBuy;
                currencySymbol = '$';
            }
        }

        let formattedAmount = currencySymbol + ' ' + formatNumberWithDecimals(amountCompany.toFixed(2));
        let rateDisplay = operation === 'sell' ? company.rateSell.toFixed(3) : company.rateBuy.toFixed(3);

        container.append(`
            <a href="${company.site}" target="_blank" class="btn-company-link text-decoration-none best-option-item p-2 d-flex align-items-center justify-content-between transition-all" 
               style="background: var(--bg-secondary); border-radius: 12px; border: 1px solid #E2E8F0;"
               onmouseover="this.style.background='var(--bg-tertiary)'; this.style.borderColor='#3B82F6';"
               onmouseout="this.style.background='var(--bg-secondary)'; this.style.borderColor='#E2E8F0';"
               data-company="${company.slug}" data-action="go-change-top3"
               >
                <div class="d-flex align-items-center gap-2">

                    <picture>
                        <source type="image/webp" srcset="${company.logo}">
                        <img class="exchange-company-logo" src="${company.logo}" alt="${company.name}" width="120" height="40" style="object-fit: contain;">
                    </picture>
                </div>
                <div class="text-end">
                    <div class="fw-bold" style="font-size: 0.9rem; color: var(--text-primary);">${formattedAmount}</div>
                    <div style="font-size: 0.65rem; color: var(--text-primary);">T.C: ${rateDisplay}</div>
                </div>
            </a>
        `);
    });
}

// Card Detail Toggle
$(document).on('click', '.btn-card-details', function (e) {
    let slug = $(this).data('company');
    $(`#details-${slug}`).slideToggle();
    $(this).find('i').toggleClass('bi-info-circle bi-x-circle');
});
$('input.calculator-amount').on('input', function (event) {
    let input = $(this);
    let value = input.val();
    let cursorPosition = input[0].selectionStart;

    // Eliminar caracteres no numéricos excepto punto
    value = value.replace(/[^0-9.]/g, '');

    let parts = value.split('.');

    // Limitar a 10 dígitos en total (excluyendo el punto decimal)
    let totalDigits = parts[0].length + (parts[1] ? parts[1].length : 0);
    if (totalDigits > 10) {
        if (parts[1]) {
            parts[1] = parts[1].substr(0, 10 - parts[0].length);
        } else {
            parts[0] = parts[0].substr(0, 10);
        }
    }

    // Manejar la parte decimal
    if (parts.length > 1) {
        parts[1] = parts[1].substr(0, 2);  // Limitar a 2 decimales
    }

    // Formatear con comas para miles
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Reconstruir el valor
    value = parts.join('.');

    // Contar comas antes del cursor
    let commasBefore = (input.val().substr(0, cursorPosition).match(/,/g) || []).length;

    // Actualizar el valor del input
    input.val(value);

    // Contar comas después de la actualización
    let commasAfter = (value.substr(0, cursorPosition).match(/,/g) || []).length;

    // Ajustar la posición del cursor
    let newPosition = cursorPosition + (commasAfter - commasBefore);

    // Establecer la posición del cursor
    input[0].setSelectionRange(newPosition, newPosition);
});

// $('#btn-feedback').on('click', function () {
//     $([document.documentElement, document.body]).animate({
//         scrollTop: $('#calculator:visible').offset().top - 100
//     }, 500);
// });

$(document).on('click', '.remove-company', function () {
    let company = $(this).data('company');
    // $('#multiSelect option[value="' + company + '"]').prop('selected', false);
    $('div[data-company="' + company + '"]').fadeOut(500, function () {
        $(this).remove();
        $('#multiSelect').trigger('change');
    });
})

async function initTour() {
    const { driver } = await import('driver.js');
    const driverObj = driver({
        popoverClass: 'driverjs-theme',
        // showProgress: true,
        nextBtnText: 'Siguiente <i class="bi bi-chevron-compact-right"></i>',
        prevBtnText: '<i class="bi bi-chevron-compact-left"></i> Atrás',
        doneBtnText: ' Finalizar <i class="bi bi-check-circle-fill"></i>',
        steps: [
            // {
            //     popover: {
            //         title: 'Bienvenido a comparaeldolar.com', description: `Estimado usuario <i class="bi bi-person-circle"></i> hemos creado esta herramienta con el objetivo de brindarte la <b>mejor experiencia</b> y la <b>más actualizada información</b> de esta forma puedas tomar la mejor decisión al cambiar dólares.
            // <p>¡Te haremos un Tour rápido por la plataforma y así le <b>saques el mayor provecho!</b></p>`, side: "bottom", align: 'start', nextBtnText: 'Iniciar'
            //     }
            // },
            { element: '#container-op-selection', popover: { title: 'Monto que tengo o quiero', description: 'Según tu necesidad puedes elegir si el calculo se hara basado en <b>lo que tienes o quieres.</b>', side: "bottom", align: 'start' } },
            { element: '#btn-swap-mode', popover: { title: 'Cambiar moneda', description: 'Según la elección del paso anterior puedes <b>cambiar la moneda</b> apretando el botón <i class="bi bi-arrow-down-up"></i>', side: "top", align: 'start' } },
            { element: '#input-calculator-container', popover: { title: 'Monto a cambiar', description: 'Con el monto ingresado se calculará el monto a cambiar en la tabla de casas de cambio.', side: "bottom", align: 'start' } },
            { element: '#rankingMenu', popover: { title: 'Compara el mejor tipo de cambio', description: 'Con estos filtros puedes elegir entre ver <b>Todo</b> o solo <b>tus casas favoritos</b>.' } },
            { element: '#exchange-companies > thead', popover: { title: 'Ordena como desees', description: 'Algunas columnas tienen los simbos de <i class="bi bi-arrow-down-up"></i> con los cuales puedes hacer un orden ascendente o descendente.', side: "top", align: 'start' } },
            { element: '#exchange-companies > tbody', popover: { title: 'Compara y visita', description: 'Finalmente puedes visitar la pagina web de la casa o compararla con otras.', side: "top", align: 'start' } },
        ]
    });

    driverObj.drive();
}
$('#tour-btn').on('click', function () {
    initTour();
});

function getBlogPosts() {

    $.ajax({
        type: 'get',
        url: POST_ROUTE,
        success: function (data) {
            $('#blog-posts').html('');
            $.each(data.data, function (k, v) {
                let image = '';
                if (v.thumbnail_url) {
                    image = `<img src="${v.thumbnail_url}" width="${v.width}" height="${v.height}" class="card-img-top" alt="${v.alt_text}" loading="lazy"> `;
                }
                $('#blog-posts').append(`
                <div class="col-md-6 col-xl-4 p-3">
                    <div class="card">
                        ${image}
                        <div class="card-body">
                            <a href="${v.link}" class="text-neutral font-20"> <b>${v.title.rendered}</b> </a>
                            <p class="font-16 text-neutral">${v.excerpt.rendered}</p>
                            <a href="${v.link}" class="btn btn-outline-dark-blue">Leer más</a>
                        </div>
                    </div>
                </div>
            `);
            });

        }
    })
}


$('#feedbackButton').on('click', function () {
    const modalBody = $('#feedbackModal .modal-body');
    // Only load if empty or containing the spinner
    if (modalBody.find('#google-form-iframe').length === 0) {
        modalBody.html(`
            <iframe id="google-form-iframe"
                src="https://docs.google.com/forms/d/e/1FAIpQLSez17pDvhyeIjx5Uuts-BBqGe-PDRcFjVqlN9e8W2vys4zZrA/viewform?embedded=true"
                width="100%" height="800" frameborder="0" marginheight="0" marginwidth="0"
                style="border-radius: 0 0 var(--radius-xl) var(--radius-xl);">Cargando…</iframe>
        `);
    }
});
$('#next-modal-intro').on('click', function () {
    if (formIntroAmount.valid()) { // Sólo avanza si el formulario es válido
        $(this).hide();
        $('#init-tour,#not-init-tour').removeClass('d-none');
        $('#home-tab-pane').removeClass('active show');
        $('#amount-tab-pane').addClass('active show');
    }
});
const formIntroAmount = $("#form-intro-amount");

formIntroAmount.validate({
    rules: {
        "intro-amount": {
            required: true,
            digits: true, // Solo permite números
            min: 1, // Asegura que sea positivo
            maxlength: 8 // Máximo de 8 caracteres
        },
        "introCheck": {
            required: true,
        }
    },
    messages: {
        "intro-amount": {
            required: "Por favor, introduce el monto que deseas cambiar",
            digits: "Por favor, introduce solo números",
            min: "El valor debe ser positivo",
            maxlength: "El valor no debe exceder 8 digitos"
        },
        "introCheck": {
            required: "Por favor, Selecciona si deseas cambiar soles o dolares",
        }
    }
});

$('#not-init-tour').on('click', function () {
    introModal.hide();
    $('#apply-btn').trigger('click');
});

$('#init-tour').on('click', function () {
    $('#apply-btn').trigger('click');
    introModal.hide();
    initTour();
});

document.getElementById('introModal').addEventListener('hidden.bs.modal', function () {
    runApp();
});

$('#intro-amount').on('keyup', function () {
    $('#calculator-amount').val($(this).val());
    setLocalStorageItem('calculator-amount', $(this).val());
    $('#calculator-amount').trigger('keyup');
})
$('input[name="introCheck"]').on('change', function () {
    let opt = $('input[name="introCheck"]:checked').val();
    console.log(opt);
    $('input[name="coin"]').filter(`[value="${opt}"]`).prop("checked", true);
    setLocalStorageItem('coin', opt);
})

$('.calculator-switch-icon').on('click', function () {
    $('.calculator-switch-icon').css({
        'transition': 'transform 0.5s ease',
        'transform': 'rotate(' + currentRotation + 'deg)'
    });
    currentRotation += 180;
    toggleCoinCalculator();
});

function toggleCoinCalculator() {
    let currentCoin = $('input[name="coin"]:checked').val();
    let nextCoin = (currentCoin == 'SOL') ? 'USD' : 'SOL';

    $(`input[name="coin"][value="${nextCoin}"]`).prop('checked', true).trigger('change');
}

$('#calculator-tabs li a').on('click', function () {
    let id = $(this).attr('id');
    selectMode(id);
});
function getCalculatorExplainPhrase(mode, coin) {
    let phrase = '';
    if (mode == 'send_amount') {
        if (coin == 'SOL') {
            phrase = `<b>Tengo Soles </b> y quiero Dólares.`;
        } else {
            phrase = `<b>Tengo Dólares</b> y quiero Soles.`;
        }
    } else if (mode == 'receive_amount') {
        if (coin == 'SOL') {
            phrase = `<b>Quiero Soles</b> y tengo Dólares.`;
        } else {
            phrase = `<b>Quiero Dólares</b> y tengo Soles.`;
        }
    }
    return phrase;
}
function selectMode(mode) {
    $('#calculator-tabs li a').removeClass('active');
    $('#' + mode).addClass('active');
    setLocalStorageItem("mode", mode);
    let val = $('input[name="coin"]:checked').val();
    if (mode == 'send_amount') {
        $('.coin-label.send').text('Tengo')
        $('.coin-label.receive').text('Quiero')
    } else if (mode == 'receive_amount') {
        $('.coin-label.receive').text('Tengo')
        $('.coin-label.send').text('Quiero')
    }
    $('#calculator-explain-phrase').html(getCalculatorExplainPhrase(mode, val));
}
// $(document).on('click', '.btn-star', function () {
//     let company = $(this).data('company');
//     if ($(this).hasClass('bi-star')) {//no esta starred y con este click lo starreo
//         let stars = JSON.parse(getLocalStorageItem('stars'));
//         stars.push(company);
//         setLocalStorageItem('stars', JSON.stringify(stars));
//     } else if ($(this).hasClass('bi-star-fill')) {//esta starred y con este click le quito starreo
//         let stars = JSON.parse(getLocalStorageItem('stars'));
//         stars.pop(company);
//         setLocalStorageItem('stars', JSON.stringify(stars));
//     }
//     $(this).toggleClass('bi-star-fill');
//     $(this).toggleClass('bi-star');
//     if ($('#filter-only-stars').is(':checked')) {
//         toggleStarred();
//     }

//     trackEvent({
//         'event': 'click',
//         'value': company,
//         'action': 'star-company'
//     }, true);
// })

// $('#filter-only-stars').on('change', function () {
//     toggleStarred();
// });

// function toggleStarred() {
//     let ele = $('#filter-only-stars');
//     if (ele.is(':checked')) {
//         let hasStars = $('#exchange-companies tbody tr').has('td .btn-star.bi-star-fill');
//         if (hasStars.length == 0) {
//             ele.prop('checked', false);
//             alert('No tiene favoritos aún. Dale click sobre el icono de estrella ☆ para agregar a favoritos.');
//         } else {
//             $('#exchange-companies tbody tr').has('td .btn-star.bi-star').hide()
//         }

//     } else {
//         $('#exchange-companies tbody tr').show()
//     }
// }


$(document).on('click', '.btn-company-link', function (e) {
    let action = $(this).data('action');
    let company = $(this).data('company');
    if ($('#switchFavorites').is(':checked')) {
        action = 'go-change-my-selection'
    }
    trackEvent({
        'event': 'click',
        'value': company,
        'action': action
    }, true);
})
/*
    'event' =>'required|string',
    'value' =>'required|string',
    'action' =>'required|string',
    'mode' =>'string',
    'coin' =>'string',
    'amount' =>'numeric',
    'compared_to' =>'array'
*/
function trackEvent(args, addLocalStorage = false) {
    if (addLocalStorage) {
        let calcMode = null;
        if (getLocalStorageItem("calc-mode") == 'have' && getLocalStorageItem("operation") == 'sell') {
            calcMode = 'SOL';
        } else if (getLocalStorageItem("calc-mode") == 'have' && getLocalStorageItem("operation") == 'buy') {
            calcMode = 'USD';
        } else if (getLocalStorageItem("calc-mode") == 'want' && getLocalStorageItem("operation") == 'sell') {
            calcMode = 'USD';
        } else if (getLocalStorageItem("calc-mode") == 'want' && getLocalStorageItem("operation") == 'buy') {
            calcMode = 'SOL';
        }
        args['mode'] = getLocalStorageItem("operation") || null;
        args['coin'] = calcMode;
        args['amount'] = getLocalStorageItem("calculator-amount") ? getLocalStorageItem("calculator-amount").replace(/,/g, "") : $('#calculator-amount').val().replace(/,/g, "");
        args['compared_to'] = getLocalStorageItem("options") ? JSON.parse(getLocalStorageItem("options")) : null;
        // args['stars'] = getLocalStorageItem("stars") ? JSON.parse(getLocalStorageItem("stars")) : null;
    }
    if (!getLocalStorageItem('visitorId')) {
        setLocalStorageItem('visitorId', crypto.randomUUID());
    }
    args['visitor_id'] = getLocalStorageItem('visitorId');

    $.ajax({
        url: BASE_URL + '/track-event',
        type: 'POST',
        data: args,
        success: function (data) {
            console.log(data);
        }
    });
}
function initTooltips() {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach(tooltipTriggerEl => {
        if (!tooltipTriggerEl.hasAttribute('data-bs-original-title')) {
            new bootstrap.Tooltip(tooltipTriggerEl, {
                trigger: 'hover',
                container: '.container'
            });
        }

    });
    console.log('removito toltip');

    $('.tooltip.ced-tooltip').remove();


}
function formatNumberWithDecimals(number) {

    // Define a regular expression that matches groups of three digits
    let regex = /(\d)(?=(\d{3})+(?!\d))/g;

    // Define the replacement string that adds a comma
    // after each group of three digits
    let replacement = "$1,";

    // Format the number using the replace() method
    return number.toString().replace(regex, replacement);
}
function formatColumnBanks(banks) {
    let content = '';
    $.each(banks, function (k, bank) {
        content += `<img src="${BASE_URL}/images/banks/${bank}.svg" class="me-1" alt="${bank}" width="24" height="24" loading="lazy"/>`;
    })
    return content;
}

const toastTrigger = document.getElementById('apply-btn')
const toastApply = document.getElementById('apply-toast')
const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastApply)

function orderTable() {
    let mode = getLocalStorageItem('operation');
    if (typeof table !== 'undefined' && $.fn.DataTable.isDataTable(table)) {
        if (mode == 'sell') {//casa vende
            table.order([[4, 'asc']]).draw();
            sortMobileCards('sell', 'asc');
        } else {// casa compra
            table.order([[3, 'desc']]).draw();
            sortMobileCards('buy', 'desc');
        }
    } else {
        alert('Aún estamos cargando la información de la tabla de casas de cambio. Inténtalo de nuevo en breve.');
    }
}
$('#apply-btn').on('click', function () {
    let mode = $('#calculator-tabs a.active').attr('id');
    let coin = $('input[name="coin"]:checked').val();
    if (typeof table !== 'undefined' && $.fn.DataTable.isDataTable(table)) {
        if (mode == 'send_amount') {//casa vende
            if (coin == 'SOL') {
                table.order([[4, 'asc']]).draw();
            } else {
                table.order([[3, 'desc']]).draw();
            }
        } else if (mode == 'receive_amount') {
            if (coin == 'SOL') {//casa compra
                table.order([[3, 'desc']]).draw();
            } else {
                table.order([[4, 'asc']]).draw();
            }
        }
        toastBootstrap.show()
    } else {
        alert('Aún estamos cargando la información de la tabla de casas de cambio. Inténtalo de nuevo en breve.');
    }
});

$(document).ready(function () {
    // 1. Selecciona los elementos usando jQuery
    var monitorTypeInputs = $('input[name="monitorType"]');
    var exchangeHousesList = $('#exchangeHousesList');
    var favorityHousesList = $('#favorityHousesList');
    var compraCheck = $('#compraCheck');
    var ventaCheck = $('#ventaCheck');

    // 2. Maneja el evento 'change' para los inputs 'monitorType'
    monitorTypeInputs.each(function () {
        $(this).on('change', function () {
            exchangeHousesList.addClass('d-none'); // Muestra
            favorityHousesList.addClass('d-none'); // Muestra
            if ($(this).val() === 'ms') {
                exchangeHousesList.removeClass('d-none'); // Muestra
            } else if ($(this).val() === 'favorites') {
                favorityHousesList.removeClass('d-none'); // Muestra
            }
        });
    });

    // 3.  Maneja el evento 'change' para 'compraCheck'
    compraCheck.on('change', function () {
        const isChecked = $(this).prop('checked');
        $('#buyRate').prop('disabled', !isChecked);

        if (!isChecked) {
            $('#buyRate').val(''); // Limpiar el valor cuando se deshabilita
        }

        // Verificar que al menos uno esté habilitado
        if (!isChecked && !$('#ventaCheck').prop('checked')) {
            $('#ventaCheck').prop('checked', true);
            $('#sellRate').prop('disabled', false);
        }

        // Re-validar el formulario
        alertForm.validate().element('#buyRate');
    });

    // 4. Maneja el evento 'change' para 'ventaCheck'
    ventaCheck.on('change', function () {
        const isChecked = $(this).prop('checked');
        $('#sellRate').prop('disabled', !isChecked);

        if (!isChecked) {
            $('#sellRate').val(''); // Limpiar el valor cuando se deshabilita
        }

        // Verificar que al menos uno esté habilitado
        if (!isChecked && !$('#compraCheck').prop('checked')) {
            $('#compraCheck').prop('checked', true);
            $('#buyRate').prop('disabled', false);
        }

        // Re-validar el formulario
        alertForm.validate().element('#sellRate');
    });
});
const alertForm = $("#alertForm");
const alertModal = new bootstrap.Modal(document.getElementById('alertModal'))
$.validator.addMethod("buyOrSellRequired", function (value, element, params) {
    const buy = $('#buyRate');
    const sell = $('#sellRate');

    const buyEnabled = !buy.prop('disabled');
    const sellEnabled = !sell.prop('disabled');

    // Si ambos están deshabilitados, falla la validación
    if (!buyEnabled && !sellEnabled) {
        return false;
    }

    // Si están habilitados, verificar valores válidos
    const buyVal = parseFloat(buy.val());
    const sellVal = parseFloat(sell.val());

    // Validar solo los campos habilitados
    let buyValid = true;
    let sellValid = true;

    if (buyEnabled) {
        if (isNaN(buyVal) || buyVal < 3.2 || buyVal > 4.2) {
            buyValid = false;
        } else {
            const decimalesBuy = (buyVal.toString().split('.')[1] || '').length;
            if (decimalesBuy > 3) {
                buyValid = false;
            }
        }
    }

    if (sellEnabled) {
        if (isNaN(sellVal) || sellVal < 3.2 || sellVal > 4.2) {
            sellValid = false;
        } else {
            const decimalesSell = (sellVal.toString().split('.')[1] || '').length;
            if (decimalesSell > 3) {
                sellValid = false;
            }
        }
    }

    return buyValid && sellValid;
}, "Ingresa un valor valido del tipo de cambio que deseas monitorear (máximo 3 decimales).");
$.validator.addMethod("amountFormat", function (value, element) {
    // Expresión regular:
    // ^                 -> Inicio de la cadena
    // \d{1,6}           -> Uno a seis dígitos enteros (0-9)
    // (                 -> Inicio de grupo opcional (para los decimales)
    //   \.              -> Un punto decimal (escapado)
    //   \d{1,2}         -> Uno o dos dígitos decimales (0-9)
    // )?                -> El grupo de decimales es opcional (cero o una vez)
    // $                 -> Fin de la cadena
    return this.optional(element) || /^\d{1,7}(\.\d{1,2})?$/.test(value);
}, "El monto debe tener un máximo de 7 dígitos enteros y 2 decimales.");
alertForm.validate({
    ignore: [], // Importante: no ignores los deshabilitados para que podamos capturarlos manualmente
    rules: {
        "monitorType": {
            required: true
        },
        "alert-exchanges[]": {
            required: function () {
                return $("input[name='monitorType']:checked").val() === "ms";
            },
            minlength: function () {
                return $("input[name='monitorType']:checked").val() === "ms" ? 1 : 0;
            }
        },
        // Aplica la validación a ambos campos
        "buy_rate": {
            buyOrSellRequired: true
        },
        "sell_rate": {
            buyOrSellRequired: true
        },
        "amount": {
            required: true,    // El campo es obligatorio
            number: true,      // Debe ser un número (maneja puntos decimales)
            amountFormat: true // Aplica nuestra regla de formato personalizado
        },
        "expired_at": {
            required: true,
            number: true
        }
    },
    messages: {
        "alert-exchanges[]": {
            required: "Selecciona al menos una casa de cambio si elegiste 'Mi selección'.",
            minlength: "Debes seleccionar al menos una casa de cambio."
        }
    },
    onkeyup: function (element) {
        $(element).valid();
    },
    onfocusout: function (element) {
        $(element).valid();
    }
});
// Forzar la re-validación cuando cambian los campos buyRate y sellRate
$('#buyRate').on('keyup change', function () {
    alertForm.validate().element($("input[name='buy_rate']")); // Re-valida buy_rate
});

$('#sellRate').on('keyup change', function () {
    alertForm.validate().element($("input[name='sell_rate']")); // Re-valida sell_rate
});

$('#alertRegisterBtn').on('click', function () {
    console.log('valido', alertForm.valid())
    if (alertForm.valid()) { // Sólo avanza si el formulario es válido
        const formData = new FormData(alertForm[0]);
        const visitor_id = getLocalStorageItem('visitorId');
        if (visitor_id) {
            formData.append('visitor_id', visitor_id);
        }

        // Preparar los datos para el formato correcto que espera el backend
        let exchangeHouses = [];

        if ($("input[name='monitorType']:checked").val() === "ms") {
            // Recopilar todos los checkboxes seleccionados
            $("input[name='alert-exchanges[]']:checked").each(function () {
                exchangeHouses.push($(this).val());
            });
        } else if ($("input[name='monitorType']:checked").val() === "favorites") {
            exchangeHouses = JSON.parse(getLocalStorageItem("options"));
            if (exchangeHouses.length <= 0) {
                alert('En el paso 2, seleccionaste Favoritos ,pero no tienes ningun favorito agregado.');
                return false;
            }
        }

        if (exchangeHouses.length > 0) {
            // Eliminar alert-exchanges[] si existe y agregar exchangeHouses[]
            formData.delete('alert-exchanges[]');
            exchangeHouses.forEach(house => {
                formData.append('exchange_houses[]', house);
            });
        } else {
            alert('Debes seleccionar al menos una casa de cambio para continuar.');
            return false;
        }

        $.ajax({
            type: 'POST',
            url: SAVE_ALERT_ROUTE,
            data: formData,
            processData: false,  // Importante para FormData
            contentType: false,  // Importante para FormData
            success: function (data) {
                // Resetear el formulario después de éxito
                alertForm[0].reset();

                // También resetear el estado de los campos de compra y venta
                $('#buyRate').prop('disabled', false);
                $('#sellRate').prop('disabled', false);
                $('#compraCheck').prop('checked', true);
                $('#ventaCheck').prop('checked', true);

                // Restablecer cualquier estado de error
                alertForm.validate().resetForm();

                // Ocultar los divs de selección si es necesario
                $("#exchangeHousesList").addClass("d-none");
                $("#favorityHousesList").addClass("d-none");
                alertModal.hide();
                console.log(data.message);
                alert('La alerta de monitoreo del tipo de cambio se ha guardado correctamente.');
            },
            error: function (xhr, status, error) {
                if (xhr.responseJSON && xhr.responseJSON.message) {
                    alertModal.hide();
                    alert(xhr.responseJSON.message);
                } else {
                    alert("Ocurrió un error al guardar la alerta. Por favor, inténtalo de nuevo.");
                }
            }
        });
    }
});
$('#alert-btn').on('click', function () {
    alertModal.show();
    console.log(getLocalStorageItem("options"), JSON.parse(getLocalStorageItem("options")).length)
    if (getLocalStorageItem("options") && JSON.parse(getLocalStorageItem("options")).length > 0) {
        let favorites = JSON.parse(getLocalStorageItem("options")).join('</span> <span class="badge text-bg-primary text-wrap">');
        $('#favorityHousesList').html(`Se enviará la alerta cuando alguno de sus favoritos se acerque al tipo de cambio deseado.<br> <b>Mis Favoritos son:</b><br> <span class="badge text-bg-primary text-wrap">${favorites}</span>`);
    } else {
        $('#favorityHousesList').html(`<div class="text-bg-danger p-3">¡Ud. no tiene ningún favorito agregado aún! Debe ir al listado de casas de cambio y dar clic en el <i class="bi bi-heart"></i> para empezar a agregarlos.</div>`);
    }
    // checkNotificationPermission()
    //     .then(() => {
    //         // Notificaciones habilitadas, continuar con la lógica del modal
    //         alertModal.show();
    //         if (getLocalStorageItem("options")) {
    //             let favorites = JSON.parse(getLocalStorageItem("options")).join('</span> <span class="badge text-bg-primary text-wrap">');
    //             $('#favorityHousesList').html(`Se enviara el alerta cuando alguno de sus favoritos se acerque al tipo de cambio deseado: <span class="badge text-bg-primary text-wrap">${favorites}</span>`);
    //         }
    //     })
    //     .catch(error => {
    //         // Notificaciones no habilitadas, mostrar mensaje y evitar que se abra el modal
    //         event.preventDefault(); // Evita que el modal se abra
    //         alert(error); // Muestra el mensaje de error (puedes usar un modal más bonito)
    //     });

});
// $('#alertModal').on('show.bs.modal', function () {
//     const modal = $(this);


// });

function checkNotificationPermission() {
    return new Promise((resolve, reject) => {
        if (!("Notification" in window)) {
            // El navegador no soporta notificaciones
            reject("Este navegador no soporta notificaciones.");
            return;
        }

        if (Notification.permission === "granted") {
            // Las notificaciones ya están habilitadas
            resolve(true);
            return;
        }

        if (Notification.permission === "denied") {
            // El usuario ha denegado las notificaciones
            reject("Has bloqueado las notificaciones. Por favor, habilítalas en la configuración de tu navegador.");
            return;
        }

        // Solicitar permiso al usuario
        Notification.requestPermission().then(permission => {
            if (permission === "granted") {
                resolve(true);
            } else if (permission === "denied") {
                reject("Has bloqueado las notificaciones. Por favor, habilítalas en la configuración de tu navegador.");
            } else {
                reject("No has permitido las notificaciones. Por favor, inténtalo de nuevo.");
            }
        });
    });
}
// const toastElIa = document.getElementById('ia-toast');
// const toastIa = new bootstrap.Toast(toastElIa);
// toastIa.show();

// End of welcome.js
